if ($('.id-1').length) {

  $('.next-to-carousel-banners').slick({
    slidesToShow: 3.5,
    slidesToScroll: 1,
    infinite: false,
    autoplay: false,
    dots: true,
    arrows: true,
    responsive: [
      {
        breakpoint:991,
        settings: {
          slidesToShow:2.5
        }
      },
      {
        breakpoint:767,
        settings: {
          slidesToShow:1.5,
          arrows: true,
        }
      }
    ]
  });

  $('.content .products-block').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    autoplay: false,
    dots: true,
    arrows: true,
    responsive: [
      {
        breakpoint:1199,
        settings: {
          slidesToShow:3.5
        }
      },
      {
        breakpoint:991,
        settings: {
          slidesToShow:2.5
        }
      },
      {
        breakpoint:991,
        settings: {
          slidesToShow:1.8
        }
      },
      {
        breakpoint:479,
        settings: {
          slidesToShow:1.5
        }
      }
    ]
  });

  $('.homepage-products-heading-3').append(
    '<a href="/obchod/" class="btn-simple">Všechny produkty</a>'
  );

  $('.homepage-products-heading-6').append(
    '<a href="/obchod/" class="btn-simple">Všechny produkty</a>'
  );

  $('#footer .footer-icons').insertAfter('.homepage-box.middle-banners-wrapper');

  $('.homepage-blog-wrapper .news-item').appendTo('.hp-blog .blog-items');

  if ($('.mobile').length) {
    $('#footer .footer-icons').appendTo('#content .banners-content.body-banners')
  }
}

if ($('.svihaci').length) {
  $(".svihaci").length && $(".svihaci .svihaci-in").slick({
    slidesToShow: 3.8,
    slidesToScroll: 1,
    infinite: true,
    autoplay: false,
    dots: true,
    arrows: true,
    responsive: [{
      breakpoint: 1200,
      settings: {
        slidesToShow: 3.2
      }
    }, {
      breakpoint: 991,
      settings: {
        slidesToShow: 2.2
      }
    }, {
      breakpoint: 767,
      settings: {
        infinite: false,
        slidesToShow: 1.8
      }
    }, {
      breakpoint: 479,
      settings: {
        infinite: false,
        slidesToShow: 1.2
      }
    }, {
      breakpoint: 375,
      settings: {
        infinite: false,
        slidesToShow: 1.2
      }
    }]
  });
}